module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_3.96630f90.png";